"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgText(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm0 .59a.6005.6005 0 0 1 .6062-.591h13.7912a.6005.6005 0 0 1 .6062.591v2.8134c0 .325-.1825.591-.4053.591a.88.88 0 0 1 -.6495-.5408l-.5253-.9436a1.01291 1.01291 0 0 0 -.85-.5408h-2.9835a.6005.6005 0 0 0 -.6062.591v11.2685a.84819.84819 0 0 0 .5808.761l1.8655.372a.76248.76248 0 0 1 .5807.6044c0 .239-.2727.4347-.6061.4347h-7.8047c-.3334 0-.6061-.1957-.6061-.4347a.76248.76248 0 0 1 .5807-.6044l1.834-.372a.84821.84821 0 0 0 .5807-.761v-11.2687a.6005.6005 0 0 0 -.6062-.591h-2.9519a1.01331 1.01331 0 0 0 -.8506.5411l-.5249.9438a.88.88 0 0 1 -.65.5411c-.223 0-.4058-.266-.4058-.591v-2.814z' })));
}
exports.default = SvgText;
